import { ActionContext } from 'vuex'
import Vue from 'vue'
import apiUser from '@/api/user'
import apiMns from '@/api/mns'
import apiMailTemplate from '@/api/mailTemplate'
import apiMailSkin from '@/api/mailSkin'
import apiPiscine from '@/api/piscine'
import apiActivity from '@/api/activity'
import apiForfait from '@/api/forfait'
import apiContact from '@/api/contact'
import apiNewsletter from '@/api/newsletter'
import apiCours from '@/api/cours'
import apiCommande from '@/api/commande'
import apiFamily from '@/api/family'
import util from '@/utils/classToObject'
import actionsTypes from '@/store/all-action-types'
import types from './all-mutation-types'
import { IRootState, emptyAction, actionEnsure, payloadAction } from '@/store'
import { IAdministrationState } from './state'
import { buildStateItem } from '@/models/alo/StateItem'
import { AloUser } from '@/models/alo/AloUser'
import { AloMailSkin } from '@/models/alo/AloMailSkin'
import { AloMailTemplate } from '@/models/alo/AloMailTemplate'
import { AlsUser } from '@/models/als/AlsUser'
import { AloPiscine } from '@/models/alo/AloPiscine'
import { AloActivity } from '@/models/alo/AloActivity'
import { AloForfait } from '@/models/alo/AloForfait'
import { AloMns } from '@/models/alo/AloMns'
import { AloContact } from '@/models/alo/AloContact'
import { AloNewsletter } from '@/models/alo/AloNewsletter'
import { AloCours } from '@/models/alo/AloCours'
import { AlsCours } from '@/models/als/AlsCours'
import { AloCommande } from '@/models/alo/AloCommande'
import { AloFamily } from '@/models/alo/AloFamily'
import { CommitAction } from '@/enum/CommitAction'

export class AdministrationAction {
          
    
    //////////////////////////////////////////////////////////////////
    // USER
    /////////////////////////////////////////////////////////////////

    public [types.ADM_USER_REQUEST](context: ActionContext<IAdministrationState, IRootState>,usrFilter:AlsUser|null) {
        return usrFilter?
                payloadAction(context,types.ADM_USER_REQUEST,types.ADM_USER_SUCCESS,types.ADM_USER_ERROR,apiUser.getFilterUser,usrFilter,usrFilter.commit)
               :emptyAction(context,types.ADM_USER_REQUEST,types.ADM_USER_SUCCESS,types.ADM_USER_ERROR,apiUser.getAllUser)    
    }

    public [types.ADM_USER_ENSURE](context: ActionContext<IAdministrationState, IRootState>) {
        return actionEnsure(context,types.ADM_USER_REQUEST,context.state.userList)    
    }

    public [types.ADM_USER_DETAIL_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        return payloadAction(context,types.ADM_USER_DETAIL_REQUEST,types.ADM_USER_DETAIL_SUCCESS,types.ADM_USER_DETAIL_ERROR,apiUser.getUser,id)
    }

    public [types.ADM_USER_DETAIL_ENSURE](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        //Hack car le detail n'est pas dans un stateItems
        const item = context.state.userDic[id];
        return actionEnsure(context,types.ADM_USER_DETAIL_REQUEST,buildStateItem(item,item?5:-5),id)
    }

    public [types.ADM_USER_SAVE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,data: AloUser) {
        return payloadAction(context,types.ADM_USER_SAVE_REQUEST,types.ADM_USER_SAVE_SUCCESS,types.ADM_USER_SAVE_ERROR,apiUser.saveUser,data).then((user)=>{
            if(context.getters.user.id == data.id) context.dispatch(actionsTypes.AUTH_UPDATE_USER,user)
        })    
    }

    public [types.ADM_USER_SAVE_MEMBER_REQUEST](context: ActionContext<IAdministrationState, IRootState>,data: AloUser) {
        return payloadAction(context,types.ADM_USER_SAVE_MEMBER_REQUEST,types.ADM_USER_SAVE_MEMBER_SUCCESS,types.ADM_USER_SAVE_MEMBER_ERROR,apiUser.saveMemberUser,data).then((user)=>{            
            if(context.getters.user.famId == user.famId) context.dispatch(actionsTypes.AUTH_USER_REQUEST)
        })    
    }
    

    public [types.ADM_USER_DELETE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id: number) {
        return payloadAction(context,types.ADM_USER_DELETE_REQUEST,types.ADM_USER_DELETE_SUCCESS,types.ADM_USER_DELETE_ERROR,apiUser.deleteUser,id)    
    }

    public [types.ADM_USER_RESET_STATUS](context: ActionContext<IAdministrationState, IRootState>) {
        return new Promise((resolve, reject) => {
            context.commit(types.ADM_USER_RESET_STATUS)
            resolve()
        })
    }


    //////////////////////////////////////////////////////////////////
    // MAIL_TEMPLATE
    /////////////////////////////////////////////////////////////////

    public [types.ADM_MAIL_TEMPLATE_REQUEST](context: ActionContext<IAdministrationState, IRootState>) {
        return emptyAction(context,types.ADM_MAIL_TEMPLATE_REQUEST,types.ADM_MAIL_TEMPLATE_SUCCESS,types.ADM_MAIL_TEMPLATE_ERROR,apiMailTemplate.getAllMailTemplate)    
    }

    public [types.ADM_MAIL_TEMPLATE_ENSURE](context: ActionContext<IAdministrationState, IRootState>) {
        return actionEnsure(context,types.ADM_MAIL_TEMPLATE_REQUEST,context.state.mailTemplateList)    
    }

    public [types.ADM_MAIL_TEMPLATE_DETAIL_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        return payloadAction(context,types.ADM_MAIL_TEMPLATE_DETAIL_REQUEST,types.ADM_MAIL_TEMPLATE_DETAIL_SUCCESS,types.ADM_MAIL_TEMPLATE_DETAIL_ERROR,apiMailTemplate.getMailTemplate,id)
    }

    public [types.ADM_MAIL_TEMPLATE_DETAIL_ENSURE](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        //Hack car le detail n'est pas dans un stateItems
        const item = context.state.mailTemplateDic[id];
        return actionEnsure(context,types.ADM_MAIL_TEMPLATE_DETAIL_REQUEST,buildStateItem(item,item?5:-5),id)
    }

    public [types.ADM_MAIL_TEMPLATE_SAVE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,data: AloMailTemplate) {
        return payloadAction(context,types.ADM_MAIL_TEMPLATE_SAVE_REQUEST,types.ADM_MAIL_TEMPLATE_SAVE_SUCCESS,types.ADM_MAIL_TEMPLATE_SAVE_ERROR,apiMailTemplate.saveMailTemplate,data)    
    }

    public [types.ADM_MAIL_TEMPLATE_DELETE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id: number) {
        return payloadAction(context,types.ADM_MAIL_TEMPLATE_DELETE_REQUEST,types.ADM_MAIL_TEMPLATE_DELETE_SUCCESS,types.ADM_MAIL_TEMPLATE_DELETE_ERROR,apiMailTemplate.deleteMailTemplate,id)    
    }

    public [types.ADM_MAIL_TEMPLATE_RESET_STATUS](context: ActionContext<IAdministrationState, IRootState>) {
        return new Promise((resolve, reject) => {
            context.commit(types.ADM_MAIL_TEMPLATE_RESET_STATUS)
            resolve()
        })
    }


    //////////////////////////////////////////////////////////////////
    // MAIL_SKIN
    /////////////////////////////////////////////////////////////////

    public [types.ADM_MAIL_SKIN_REQUEST](context: ActionContext<IAdministrationState, IRootState>) {
        return emptyAction(context,types.ADM_MAIL_SKIN_REQUEST,types.ADM_MAIL_SKIN_SUCCESS,types.ADM_MAIL_SKIN_ERROR,apiMailSkin.getAllMailSkin)    
    }

    public [types.ADM_MAIL_SKIN_ENSURE](context: ActionContext<IAdministrationState, IRootState>) {
        return actionEnsure(context,types.ADM_MAIL_SKIN_REQUEST,context.state.mailSkinList)    
    }

    public [types.ADM_MAIL_SKIN_DETAIL_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        return payloadAction(context,types.ADM_MAIL_SKIN_DETAIL_REQUEST,types.ADM_MAIL_SKIN_DETAIL_SUCCESS,types.ADM_MAIL_SKIN_DETAIL_ERROR,apiMailSkin.getMailSkin,id)
    }

    public [types.ADM_MAIL_SKIN_DETAIL_ENSURE](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        //Hack car le detail n'est pas dans un stateItems
        const item = context.state.mailSkinDic[id];
        return actionEnsure(context,types.ADM_MAIL_SKIN_DETAIL_REQUEST,buildStateItem(item,item?5:-5),id)
    }

    public [types.ADM_MAIL_SKIN_SAVE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,data: AloMailSkin) {
        return payloadAction(context,types.ADM_MAIL_SKIN_SAVE_REQUEST,types.ADM_MAIL_SKIN_SAVE_SUCCESS,types.ADM_MAIL_SKIN_SAVE_ERROR,apiMailSkin.saveMailSkin,data)    
    }

    public [types.ADM_MAIL_SKIN_DELETE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id: number) {
        return payloadAction(context,types.ADM_MAIL_SKIN_DELETE_REQUEST,types.ADM_MAIL_SKIN_DELETE_SUCCESS,types.ADM_MAIL_SKIN_DELETE_ERROR,apiMailSkin.deleteMailSkin,id)    
    }

    public [types.ADM_MAIL_SKIN_RESET_STATUS](context: ActionContext<IAdministrationState, IRootState>) {
        return new Promise((resolve, reject) => {
            context.commit(types.ADM_MAIL_SKIN_RESET_STATUS)
            resolve()
        })
    }

    //////////////////////////////////////////////////////////////////
    // PISCINE
    /////////////////////////////////////////////////////////////////

    public [types.ADM_PISCINE_REQUEST](context: ActionContext<IAdministrationState, IRootState>) {
        return emptyAction(context,types.ADM_PISCINE_REQUEST,types.ADM_PISCINE_SUCCESS,types.ADM_PISCINE_ERROR,apiPiscine.getAllPiscine)    
    }

    public [types.ADM_PISCINE_ENSURE](context: ActionContext<IAdministrationState, IRootState>) {
        return actionEnsure(context,types.ADM_PISCINE_REQUEST,context.state.piscineList)    
    }

    public [types.ADM_PISCINE_DETAIL_REQUEST](context: ActionContext<IAdministrationState, IRootState>,idOrSlug:string|number) {
        return payloadAction(context,types.ADM_PISCINE_DETAIL_REQUEST,types.ADM_PISCINE_DETAIL_SUCCESS,types.ADM_PISCINE_DETAIL_ERROR,apiPiscine.getPiscine,idOrSlug)
    }

    public [types.ADM_PISCINE_DETAIL_ENSURE](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        //Hack car le detail n'est pas dans un stateItems
        const item = context.state.piscineDic[id];
        return actionEnsure(context,types.ADM_PISCINE_DETAIL_REQUEST,buildStateItem(item,item?5:-5),id)
    }

    public [types.ADM_PISCINE_SAVE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,data: AloPiscine) {
        return payloadAction(context,types.ADM_PISCINE_SAVE_REQUEST,types.ADM_PISCINE_SAVE_SUCCESS,types.ADM_PISCINE_SAVE_ERROR,apiPiscine.savePiscine,data)    
    }

    public [types.ADM_PISCINE_DELETE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id: number) {
        return payloadAction(context,types.ADM_PISCINE_DELETE_REQUEST,types.ADM_PISCINE_DELETE_SUCCESS,types.ADM_PISCINE_DELETE_ERROR,apiPiscine.deletePiscine,id)    
    }

    public [types.ADM_PISCINE_RESET_STATUS](context: ActionContext<IAdministrationState, IRootState>) {
        return new Promise((resolve, reject) => {
            context.commit(types.ADM_PISCINE_RESET_STATUS)
            resolve()
        })
    }

    //////////////////////////////////////////////////////////////////
    // ACTIVITY
    /////////////////////////////////////////////////////////////////

    public [types.ADM_ACTIVITY_REQUEST](context: ActionContext<IAdministrationState, IRootState>) {
        return emptyAction(context,types.ADM_ACTIVITY_REQUEST,types.ADM_ACTIVITY_SUCCESS,types.ADM_ACTIVITY_ERROR,apiActivity.getAllActivity)    
    }

    public [types.ADM_ACTIVITY_ENSURE](context: ActionContext<IAdministrationState, IRootState>) {
        return actionEnsure(context,types.ADM_ACTIVITY_REQUEST,context.state.activityList)    
    }

    public [types.ADM_ACTIVITY_DETAIL_REQUEST](context: ActionContext<IAdministrationState, IRootState>,idOrSlug:string|number) {
        return payloadAction(context,types.ADM_ACTIVITY_DETAIL_REQUEST,types.ADM_ACTIVITY_DETAIL_SUCCESS,types.ADM_ACTIVITY_DETAIL_ERROR,apiActivity.getActivity,idOrSlug)
    }

    public [types.ADM_ACTIVITY_DETAIL_ENSURE](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        //Hack car le detail n'est pas dans un stateItems
        const item = context.state.activityDic[id];
        return actionEnsure(context,types.ADM_ACTIVITY_DETAIL_REQUEST,buildStateItem(item,item?5:-5),id)
    }

    public [types.ADM_ACTIVITY_SAVE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,data: AloActivity) {
        return payloadAction(context,types.ADM_ACTIVITY_SAVE_REQUEST,types.ADM_ACTIVITY_SAVE_SUCCESS,types.ADM_ACTIVITY_SAVE_ERROR,apiActivity.saveActivity,data)    
    }

    public [types.ADM_ACTIVITY_DELETE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id: number) {
        return payloadAction(context,types.ADM_ACTIVITY_DELETE_REQUEST,types.ADM_ACTIVITY_DELETE_SUCCESS,types.ADM_ACTIVITY_DELETE_ERROR,apiActivity.deleteActivity,id)    
    }

    public [types.ADM_ACTIVITY_RESET_STATUS](context: ActionContext<IAdministrationState, IRootState>) {
        return new Promise((resolve, reject) => {
            context.commit(types.ADM_ACTIVITY_RESET_STATUS)
            resolve()
        })
    }

    public [types.ADM_ACTIVITY_SET_LIST](context: ActionContext<IAdministrationState, IRootState>,list:Array<number>) {
        return new Promise((resolve, reject) => {
            context.commit(types.ADM_ACTIVITY_SET_LIST,list)
            resolve()
        })
    }

    //////////////////////////////////////////////////////////////////
    // FORFAIT
    /////////////////////////////////////////////////////////////////

    public [types.ADM_FORFAIT_REQUEST](context: ActionContext<IAdministrationState, IRootState>) {
        return emptyAction(context,types.ADM_FORFAIT_REQUEST,types.ADM_FORFAIT_SUCCESS,types.ADM_FORFAIT_ERROR,apiForfait.getAllForfait)    
    }

    public [types.ADM_FORFAIT_ENSURE](context: ActionContext<IAdministrationState, IRootState>) {
        return actionEnsure(context,types.ADM_FORFAIT_REQUEST,context.state.forfaitList)    
    }

    public [types.ADM_FORFAIT_DETAIL_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        return payloadAction(context,types.ADM_FORFAIT_DETAIL_REQUEST,types.ADM_FORFAIT_DETAIL_SUCCESS,types.ADM_FORFAIT_DETAIL_ERROR,apiForfait.getForfait,id)
    }

    public [types.ADM_FORFAIT_DETAIL_ENSURE](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        //Hack car le detail n'est pas dans un stateItems
        const item = context.state.forfaitDic[id];
        return actionEnsure(context,types.ADM_FORFAIT_DETAIL_REQUEST,buildStateItem(item,item?5:-5),id)
    }

    public [types.ADM_FORFAIT_SAVE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,data: AloForfait) {
        return payloadAction(context,types.ADM_FORFAIT_SAVE_REQUEST,types.ADM_FORFAIT_SAVE_SUCCESS,types.ADM_FORFAIT_SAVE_ERROR,apiForfait.saveForfait,data)    
    }

    public [types.ADM_FORFAIT_DELETE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id: number) {
        return payloadAction(context,types.ADM_FORFAIT_DELETE_REQUEST,types.ADM_FORFAIT_DELETE_SUCCESS,types.ADM_FORFAIT_DELETE_ERROR,apiForfait.deleteForfait,id)    
    }

    public [types.ADM_FORFAIT_RESET_STATUS](context: ActionContext<IAdministrationState, IRootState>) {
        return new Promise((resolve, reject) => {
            context.commit(types.ADM_FORFAIT_RESET_STATUS)
            resolve()
        })
    }

    //////////////////////////////////////////////////////////////////
    // MNS
    /////////////////////////////////////////////////////////////////

    public [types.ADM_MNS_REQUEST](context: ActionContext<IAdministrationState, IRootState>) {
        return emptyAction(context,types.ADM_MNS_REQUEST,types.ADM_MNS_SUCCESS,types.ADM_MNS_ERROR,apiMns.getAllMns)    
    }

    public [types.ADM_MNS_ENSURE](context: ActionContext<IAdministrationState, IRootState>) {
        return actionEnsure(context,types.ADM_MNS_REQUEST,context.state.mnsList)    
    }

    public [types.ADM_MNS_DETAIL_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        return payloadAction(context,types.ADM_MNS_DETAIL_REQUEST,types.ADM_MNS_DETAIL_SUCCESS,types.ADM_MNS_DETAIL_ERROR,apiMns.getMns,id)
    }

    public [types.ADM_MNS_DETAIL_ENSURE](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        //Hack car le detail n'est pas dans un stateItems
        const item = context.state.mnsDic[id];
        return actionEnsure(context,types.ADM_MNS_DETAIL_REQUEST,buildStateItem(item,item?5:-5),id)
    }

    public [types.ADM_MNS_SAVE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,data: AloMns) {
        return payloadAction(context,types.ADM_MNS_SAVE_REQUEST,types.ADM_MNS_SAVE_SUCCESS,types.ADM_MNS_SAVE_ERROR,apiMns.saveMns,data)    
    }

    public [types.ADM_MNS_DELETE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id: number) {
        return payloadAction(context,types.ADM_MNS_DELETE_REQUEST,types.ADM_MNS_DELETE_SUCCESS,types.ADM_MNS_DELETE_ERROR,apiMns.deleteMns,id)    
    }

    public [types.ADM_MNS_RESET_STATUS](context: ActionContext<IAdministrationState, IRootState>) {
        return new Promise((resolve, reject) => {
            context.commit(types.ADM_MNS_RESET_STATUS)
            resolve()
        })
    }


    //////////////////////////////////////////////////////////////////
    // CONTACT
    /////////////////////////////////////////////////////////////////

    public [types.ADM_CONTACT_REQUEST](context: ActionContext<IAdministrationState, IRootState>,dates:Array<Date>) {
        return   dates && dates.length == 2?
                 payloadAction(context,types.ADM_CONTACT_REQUEST,types.ADM_CONTACT_SUCCESS,types.ADM_CONTACT_ERROR,apiContact.getFilterContact,dates)    
                :emptyAction(context,types.ADM_CONTACT_REQUEST,types.ADM_CONTACT_SUCCESS,types.ADM_CONTACT_ERROR,apiContact.getAllContact)    
    }

    public [types.ADM_CONTACT_ENSURE](context: ActionContext<IAdministrationState, IRootState>) {
        return actionEnsure(context,types.ADM_CONTACT_REQUEST,context.state.contactList)    
    }

    public [types.ADM_CONTACT_DETAIL_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        return payloadAction(context,types.ADM_CONTACT_DETAIL_REQUEST,types.ADM_CONTACT_DETAIL_SUCCESS,types.ADM_CONTACT_DETAIL_ERROR,apiContact.getContact,id)
    }

    public [types.ADM_CONTACT_DETAIL_ENSURE](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        //Hack car le detail n'est pas dans un stateItems
        const item = context.state.contactDic[id];
        return actionEnsure(context,types.ADM_CONTACT_DETAIL_REQUEST,buildStateItem(item,item?5:-5),id)
    }

    public [types.ADM_CONTACT_MIN_DATE_REQUEST](context: ActionContext<IAdministrationState, IRootState>) {
        return emptyAction(context,types.ADM_CONTACT_MIN_DATE_REQUEST,types.ADM_CONTACT_MIN_DATE_SUCCESS,types.ADM_CONTACT_MIN_DATE_ERROR,apiContact.getMinDate)
    }
     
    public [types.ADM_CONTACT_MIN_DATE_ENSURE](context: ActionContext<IAdministrationState, IRootState>) {
        //Hack car pas de stateItems
        const minDate = context.state.contactMinDate                
        return actionEnsure(context,types.ADM_CONTACT_MIN_DATE_REQUEST,buildStateItem(minDate,minDate?5:-5))
    }

    public [types.ADM_CONTACT_SAVE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,data: AloContact) {
        return payloadAction(context,types.ADM_CONTACT_SAVE_REQUEST,types.ADM_CONTACT_SAVE_SUCCESS,types.ADM_CONTACT_SAVE_ERROR,apiContact.saveContact,data)    
    }

    public [types.ADM_CONTACT_DELETE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id: number) {
        return payloadAction(context,types.ADM_CONTACT_DELETE_REQUEST,types.ADM_CONTACT_DELETE_SUCCESS,types.ADM_CONTACT_DELETE_ERROR,apiContact.deleteContact,id)    
    }

    public [types.ADM_CONTACT_RESET_STATUS](context: ActionContext<IAdministrationState, IRootState>) {
        return new Promise((resolve, reject) => {
            context.commit(types.ADM_CONTACT_RESET_STATUS)
            resolve()
        })
    }

    public [types.ADM_CONTACT_SET_SELECTION](context: ActionContext<IAdministrationState, IRootState>,{selected,ids}:{selected:boolean,ids:Array<number>}) {
        return new Promise((resolve, reject) => {
            context.commit(types.ADM_CONTACT_SET_SELECTION,{selected,ids})
            resolve()
        })
    }
    
    public [types.ADM_CONTACT_ACTION_ON_SELECTION_REQUEST](context: ActionContext<IAdministrationState, IRootState>,payload:{conIds:Array<number>,action:string,data?:any}) {
        return payloadAction(context,types.ADM_CONTACT_ACTION_ON_SELECTION_REQUEST,types.ADM_CONTACT_ACTION_ON_SELECTION_SUCCESS,types.ADM_CONTACT_ACTION_ON_SELECTION_ERROR,apiContact.executeActionOnSelection,payload,CommitAction.listAndDic,true)    
    }

    //////////////////////////////////////////////////////////////////
    // NEWSLETTER
    /////////////////////////////////////////////////////////////////

    public [types.ADM_NEWSLETTER_REQUEST](context: ActionContext<IAdministrationState, IRootState>) {
        return emptyAction(context,types.ADM_NEWSLETTER_REQUEST,types.ADM_NEWSLETTER_SUCCESS,types.ADM_NEWSLETTER_ERROR,apiNewsletter.getAllNewsletter)    
    }

    public [types.ADM_NEWSLETTER_ENSURE](context: ActionContext<IAdministrationState, IRootState>) {
        return actionEnsure(context,types.ADM_NEWSLETTER_REQUEST,context.state.newsletterList)    
    }

    public [types.ADM_NEWSLETTER_DETAIL_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        return payloadAction(context,types.ADM_NEWSLETTER_DETAIL_REQUEST,types.ADM_NEWSLETTER_DETAIL_SUCCESS,types.ADM_NEWSLETTER_DETAIL_ERROR,apiNewsletter.getNewsletter,id)
    }

    public [types.ADM_NEWSLETTER_DETAIL_ENSURE](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        //Hack car le detail n'est pas dans un stateItems
        const item = context.state.newsletterDic[id];
        return actionEnsure(context,types.ADM_NEWSLETTER_DETAIL_REQUEST,buildStateItem(item,item?5:-5),id)
    }

    public [types.ADM_NEWSLETTER_SAVE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,data: AloNewsletter) {
        return payloadAction(context,types.ADM_NEWSLETTER_SAVE_REQUEST,types.ADM_NEWSLETTER_SAVE_SUCCESS,types.ADM_NEWSLETTER_SAVE_ERROR,apiNewsletter.saveNewsletter,data)    
    }

    public [types.ADM_NEWSLETTER_DELETE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id: number) {
        return payloadAction(context,types.ADM_NEWSLETTER_DELETE_REQUEST,types.ADM_NEWSLETTER_DELETE_SUCCESS,types.ADM_NEWSLETTER_DELETE_ERROR,apiNewsletter.deleteNewsletter,id)    
    }

    public [types.ADM_NEWSLETTER_RESET_STATUS](context: ActionContext<IAdministrationState, IRootState>) {
        return new Promise((resolve, reject) => {
            context.commit(types.ADM_NEWSLETTER_RESET_STATUS)
            resolve()
        })
    }

    public [types.ADM_NEWSLETTER_VALID_REQUEST](context: ActionContext<IAdministrationState, IRootState>,key:string) {
        return payloadAction(context,types.ADM_NEWSLETTER_VALID_REQUEST,types.ADM_NEWSLETTER_VALID_SUCCESS,types.ADM_NEWSLETTER_VALID_ERROR,apiNewsletter.validNewsletter,key)    
    }

    public [types.ADM_NEWSLETTER_SET_SELECTION](context: ActionContext<IAdministrationState, IRootState>,{selected,ids}:{selected:boolean,ids:Array<number>}) {
        return new Promise((resolve, reject) => {
            context.commit(types.ADM_NEWSLETTER_SET_SELECTION,{selected,ids})
            resolve()
        })
    }
    
    public [types.ADM_NEWSLETTER_ACTION_ON_SELECTION_REQUEST](context: ActionContext<IAdministrationState, IRootState>,payload:{nwlIds:Array<number>,action:string,data?:any}) {
        return payloadAction(context,types.ADM_NEWSLETTER_ACTION_ON_SELECTION_REQUEST,types.ADM_NEWSLETTER_ACTION_ON_SELECTION_SUCCESS,types.ADM_NEWSLETTER_ACTION_ON_SELECTION_ERROR,apiNewsletter.executeActionOnSelection,payload,CommitAction.listAndDic,true)    
    }

    //////////////////////////////////////////////////////////////////
    // COURS
    /////////////////////////////////////////////////////////////////

    public [types.ADM_COURS_REQUEST](context: ActionContext<IAdministrationState, IRootState>,crsFilter:AlsCours|null) {
        return crsFilter?
        payloadAction(context,types.ADM_COURS_REQUEST,types.ADM_COURS_SUCCESS,types.ADM_COURS_ERROR,apiCours.getFilterCours,crsFilter,crsFilter.commit)
       :emptyAction(context,types.ADM_COURS_REQUEST,types.ADM_COURS_SUCCESS,types.ADM_COURS_ERROR,apiCours.getAllCours)       
    }

    public [types.ADM_COURS_ENSURE](context: ActionContext<IAdministrationState, IRootState>) {
        return actionEnsure(context,types.ADM_COURS_REQUEST,context.state.coursList)     
    }

    public [types.ADM_COURS_DETAIL_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        return payloadAction(context,types.ADM_COURS_DETAIL_REQUEST,types.ADM_COURS_DETAIL_SUCCESS,types.ADM_COURS_DETAIL_ERROR,apiCours.getCours,id)
    }

    public [types.ADM_COURS_DETAIL_ENSURE](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        //Hack car le detail n'est pas dans un stateItems
        const item = context.state.coursDic[id];
        return actionEnsure(context,types.ADM_COURS_DETAIL_REQUEST,buildStateItem(item,item?5:-5),id)
    }    

    public [types.ADM_COURS_SAVE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,data: AloCours) {
        return payloadAction(context,types.ADM_COURS_SAVE_REQUEST,types.ADM_COURS_SAVE_SUCCESS,types.ADM_COURS_SAVE_ERROR,apiCours.saveCours,data)    
    }

    public [types.ADM_COURS_CREATE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,data: AloCours) {
        return payloadAction(context,types.ADM_COURS_SAVE_REQUEST,types.ADM_COURS_SAVE_SUCCESS,types.ADM_COURS_SAVE_ERROR,apiCours.saveCours,data,CommitAction.dicOnly)    
    }

    public [types.ADM_COURS_CREATE_RANGE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,data: Array<AloCours>) {
        return payloadAction(context,types.ADM_COURS_SAVE_REQUEST,types.ADM_COURS_CREATE_RANGE_SUCCESS,types.ADM_COURS_SAVE_ERROR,apiCours.addRange,data)    
    }

    public [types.ADM_COURS_DELETE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id: number) {
        return payloadAction(context,types.ADM_COURS_DELETE_REQUEST,types.ADM_COURS_DELETE_SUCCESS,types.ADM_COURS_DELETE_ERROR,apiCours.deleteCours,id)    
    }

    public [types.ADM_COURS_RESET_STATUS](context: ActionContext<IAdministrationState, IRootState>) {
        return new Promise((resolve, reject) => {
            context.commit(types.ADM_COURS_RESET_STATUS)
            resolve()
        })
    }

    //////////////////////////////////////////////////////////////////
    // COMMANDE
    /////////////////////////////////////////////////////////////////
    public [types.ADM_COMMANDE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,dates:Array<Date>) {
        return   dates && dates.length == 2?
                 payloadAction(context,types.ADM_COMMANDE_REQUEST,types.ADM_COMMANDE_SUCCESS,types.ADM_COMMANDE_ERROR,apiCommande.getFilterCommande,dates)    
                :emptyAction(context,types.ADM_COMMANDE_REQUEST,types.ADM_COMMANDE_SUCCESS,types.ADM_COMMANDE_ERROR,apiCommande.getAllCommande)    
    }

    public [types.ADM_COMMANDE_ENSURE](context: ActionContext<IAdministrationState, IRootState>) {
        return actionEnsure(context,types.ADM_COMMANDE_REQUEST,context.state.commandeList)    
    }

    public [types.ADM_COMMANDE_DETAIL_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        return payloadAction(context,types.ADM_COMMANDE_DETAIL_REQUEST,types.ADM_COMMANDE_DETAIL_SUCCESS,types.ADM_COMMANDE_DETAIL_ERROR,apiCommande.getCommande,id)
    }

    public [types.ADM_COMMANDE_DETAIL_ENSURE](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        //Hack car le detail n'est pas dans un stateItems
        const item = context.state.commandeDic[id];
        return actionEnsure(context,types.ADM_COMMANDE_DETAIL_REQUEST,buildStateItem(item,item?5:-5),id)
    }

    public [types.ADM_COMMANDE_SAVE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,data: AloCommande) {
        return payloadAction(context,types.ADM_COMMANDE_SAVE_REQUEST,types.ADM_COMMANDE_SAVE_SUCCESS,types.ADM_COMMANDE_SAVE_ERROR,apiCommande.saveCommande,data)    
    }

    public [types.ADM_COMMANDE_DELETE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id: number) {
        return payloadAction(context,types.ADM_COMMANDE_DELETE_REQUEST,types.ADM_COMMANDE_DELETE_SUCCESS,types.ADM_COMMANDE_DELETE_ERROR,apiCommande.deleteCommande,id)    
    }

    public [types.ADM_COMMANDE_RESET_STATUS](context: ActionContext<IAdministrationState, IRootState>) {
        return new Promise((resolve, reject) => {
            context.commit(types.ADM_COMMANDE_RESET_STATUS)
            resolve()
        })
    }
    public [types.ADM_COMMANDE_MIN_DATE_REQUEST](context: ActionContext<IAdministrationState, IRootState>) {
        return emptyAction(context,types.ADM_COMMANDE_MIN_DATE_REQUEST,types.ADM_COMMANDE_MIN_DATE_SUCCESS,types.ADM_COMMANDE_MIN_DATE_ERROR,apiCommande.getMinDate)
    }
     
    public [types.ADM_COMMANDE_MIN_DATE_ENSURE](context: ActionContext<IAdministrationState, IRootState>) {
        //Hack car pas de stateItems
        const minDate = context.state.commandeMinDate                
        return actionEnsure(context,types.ADM_COMMANDE_MIN_DATE_REQUEST,buildStateItem(minDate,minDate?5:-5))
    }

    //////////////////////////////////////////////////////////////////
    // FAMILY
    /////////////////////////////////////////////////////////////////

    public [types.ADM_FAMILY_REQUEST](context: ActionContext<IAdministrationState, IRootState>) {
        return emptyAction(context,types.ADM_FAMILY_REQUEST,types.ADM_FAMILY_SUCCESS,types.ADM_FAMILY_ERROR,apiFamily.getAllFamily)    
    }

    public [types.ADM_FAMILY_ENSURE](context: ActionContext<IAdministrationState, IRootState>) {
        return actionEnsure(context,types.ADM_FAMILY_REQUEST,context.state.familyList)    
    }

    public [types.ADM_FAMILY_DETAIL_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        return payloadAction(context,types.ADM_FAMILY_DETAIL_REQUEST,types.ADM_FAMILY_DETAIL_SUCCESS,types.ADM_FAMILY_DETAIL_ERROR,apiFamily.getFamily,id)
    }

    public [types.ADM_FAMILY_DETAIL_ENSURE](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        //Hack car le detail n'est pas dans un stateItems
        const item = context.state.familyDic[id];
        return actionEnsure(context,types.ADM_FAMILY_DETAIL_REQUEST,buildStateItem(item,item?5:-5),id)
    }

    public [types.ADM_FAMILY_SAVE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,data: AloFamily) {
        return payloadAction(context,types.ADM_FAMILY_SAVE_REQUEST,types.ADM_FAMILY_SAVE_SUCCESS,types.ADM_FAMILY_SAVE_ERROR,apiFamily.saveFamily,data)    
    }

    public [types.ADM_FAMILY_DELETE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id: number) {
        return payloadAction(context,types.ADM_FAMILY_DELETE_REQUEST,types.ADM_FAMILY_DELETE_SUCCESS,types.ADM_FAMILY_DELETE_ERROR,apiFamily.deleteFamily,id)    
    }

    public [types.ADM_FAMILY_RESET_STATUS](context: ActionContext<IAdministrationState, IRootState>) {
        return new Promise((resolve, reject) => {
            context.commit(types.ADM_FAMILY_RESET_STATUS)
            resolve()
        })
    }
        

}

export default util.classToObject(AdministrationAction)
